export { default } from "./dialog-title";